import { useEffect, useState } from "react";
import { getCookie } from "../../App.js";
import { depositConfirmationRequest } from "./DepositConfirmationRequest.js";
import { domain } from "../Links/Links.js";

function Notifications({ theme }) {
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    console.log(getCookie("csrf_token"));
    setLoadingStatus(true);

    const notifs_count_div = document.querySelector(".notifs_count_div");
    if (notifs_count_div) {
      notifs_count_div.innerHTML = "";
    }

    const xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open("GET", domain + "/notifications/", true);
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const data = JSON.parse(xhr.responseText);
        setNotifications(data);
        console.log(data);
      }
    };
    xhr.send();
  }, []);

  return (
    <div className="mainDiv">
      <div className="headerDiv"></div>
      <div className="contentDiv">
        {!loadingStatus ? (
          <div className="fkgjjjrn4">
            {Array.from({ length: 3 }).map((_, i) => (
              <div className="kfjjej3kv" key={i}>
                <div className={`fghtrrthg shimmer ${theme}`}></div>
              </div>
            ))}
          </div>
        ) : (
          <div>
            {notifications.map((notif, index) => (
              <div key={index}>
                {notif.transaction && (
                  <>
                    {notif.transaction.token == "Toman" && (
                      <>
                        <div>
                          {notif.transaction.user} {notif.transaction.amount}{" "}
                          Deposited, {notif.transaction.memo}
                        </div>
                        <button
                          onClick={(event) => {
                            depositConfirmationRequest(
                              event,
                              notif.transaction.user,
                              notif.transaction.amount,
                              notif.notif_id,
                              notif.transaction.wallet_history_id,
                            );
                          }}
                        >
                          Confirm
                        </button>
                      </>
                    )}

                    {notif.transaction.transaction_type == "Send" ||
                      (notif.transaction.transaction_type == "Receive" && (
                        <>
                          <div>
                            {notif.transaction.sender}{" "}
                            {notif.transaction.amount} sended to{" "}
                            {notif.transaction.receiver}
                          </div>
                        </>
                      ))}
                  </>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Notifications;
